import React from 'react';
import { Link } from 'react-router-dom';
import FilterBar from './FilterBar';
import './Header.css';

const Header = ({ activeFilter, onFilterApply, onFilterClear, loading, disabled }) => {
  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="logo">
          <h1>✈️ Airpics</h1>
        </Link>
        <div className="header-search">
          <FilterBar
            activeFilter={activeFilter}
            onFilterApply={onFilterApply}
            onFilterClear={onFilterClear}
            loading={loading}
            disabled={disabled}
          />
        </div>
      </div>
    </header>
  );
};

export default Header;